const NDC_MEMBER_PATHS = ['/dashboard', '/account'];

export function isNdcInstitutePath(pathname: string) {
	return pathname === '/ndc-institute' || pathname.startsWith('/ndc-institute/');
}

export function getNavTheme(pathname: string, isLoggedIn: boolean, hasNdcAccess: boolean): 'ndc' | undefined {
	if (isNdcInstitutePath(pathname)) {
		return !isLoggedIn || hasNdcAccess ? 'ndc' : undefined;
	}
	const isMemberPath = NDC_MEMBER_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
	return isMemberPath && hasNdcAccess ? 'ndc' : undefined;
}
